// import React from 'react';
// import {Link} from 'react-router-dom'
// // import blogs from '../../api/blogs'
// import { getBlogs } from "../../api/blogs";
// import Services from '../../api/service';
// import Projects from '../../api/project'
// import about from '../../images/blog/about-widget.jpg'


// const BlogSidebar = (props) => {

//     const SubmitHandler = (e) =>{
//        e.preventDefault()
//     }

//     const ClickHandler = () =>{
//         window.scrollTo(10, 0);
//      }

//     return(
//         <div className={`col col-lg-4 col-12 ${props.blLeft}`}>
//             <div className="blog-sidebar">
//                 {/* <div className="widget about-widget">
//                     <div className="img-holder">
//                         <img src={about} alt=""/>
//                     </div>
//                     <h4>Jenny Watson</h4>
//                     <p>Hi! beautiful people. I`m an authtor of this blog. Read our post - stay with us</p>
//                     <div className="social">
//                         <ul className="clearfix">
//                             <li><Link onClick={ClickHandler} to="/blog-single/1"><i className="ti-facebook"></i></Link></li>
//                             <li><Link onClick={ClickHandler} to="/blog-single/1"><i className="ti-twitter-alt"></i></Link></li>
//                             <li><Link onClick={ClickHandler} to="/blog-single/1"><i className="ti-linkedin"></i></Link></li>
//                             <li><Link onClick={ClickHandler} to="/blog-single/1"><i className="ti-pinterest"></i></Link></li>
//                         </ul>
//                     </div>
//                     <div className="aw-shape">
//                     </div>
//                 </div> */}
//                 <div className="widget search-widget">
//                     <form onSubmit={SubmitHandler}>
//                         <div>
//                             <input type="text" className="form-control" placeholder="Search Post.."/>
//                             <button type="submit"><i className="ti-search"></i></button>
//                         </div>
//                     </form>
//                 </div>
//                 <div className="widget category-widget">
//                     {/* <h3>Categories</h3> */}
//                     <ul>
//                         {/* {Services.slice(0,6).map((service, Sitem) => (
//                         ))} */}
//                     </ul>
//                 </div>
//                 <div className="widget recent-post-widget">
//                     <h3>Related Posts</h3>
//                     <div className="posts">
//                         {getBlogs.slice(0, 3).map((blog, Bitem) => (
//                             <div className="post" key={Bitem}>
//                                 <div className="img-holder">
//                                     <img src={blog.screens} alt="" />
//                                 </div>
//                                 <div className="details">
//                                     <h4><Link onClick={ClickHandler} to={`/blog-single/${blog.id}`}>{blog.title}</Link></h4>
//                                     <span className="date">{blog.create_at}</span>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//                 {/* <div className="widget wpo-instagram-widget">
//                     <div className="widget-title">
//                         <h3>Projects</h3>
//                     </div>
//                     <ul className="d-flex">
//                         {Projects.slice(0,6).map((project, pitem)=>(
//                             <li className="grid" key={pitem}>
//                                 <div className="img-holder">
//                                     <Link onClick={ClickHandler} to={`/project-single/${project.Id}`}>
//                                         <img src={project.pImg} alt=""/>
//                                     </Link>
//                                 </div>
//                             </li>
//                         ))}
//                     </ul>
//                 </div> */}
//                 <div className="widget tag-widget">
//                     <h3>Tags</h3>
//                     <ul>
//                         <li><Link onClick={ClickHandler} to="/blog-single/1">Planning</Link></li>
//                         <li><Link onClick={ClickHandler} to="/blog-single/1">Design</Link></li>
//                         <li><Link onClick={ClickHandler} to="/blog-single/1">creative</Link></li>
//                         <li><Link onClick={ClickHandler} to="/blog-single/1">Interior</Link></li>
//                         <li><Link onClick={ClickHandler} to="/blog-single/1">Furniture</Link></li>
//                         <li><Link onClick={ClickHandler} to="/blog-single/1">Idea</Link></li>
//                         <li><Link onClick={ClickHandler} to="/blog-single/1">Decoration</Link></li>
//                         <li><Link onClick={ClickHandler} to="/blog-single/1">Architectural</Link></li>
//                     </ul>
//                 </div>
//                 <div className="wpo-contact-widget widget">
//                         <h2>How We Can <br/> Help You!</h2>
//                         <p>
//                             Our team is dedicated to turning your vision into reality, whether you need innovative architectural design, interior solutions, or expert project management. We provide personalized guidance and creative expertise at every stage, ensuring your project is completed on time and exceeds expectations.
//                         </p>
//                         <Link onClick={ClickHandler} to="/contact">Contact Us</Link>
//                 </div>
//             </div>
//         </div>
//      )
        
// }

// export default BlogSidebar;












import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getBlogs } from "../../api/blogs";
import Services from '../../api/service';
import Projects from '../../api/project';
import about from '../../images/blog/about-widget.jpg';

const BlogSidebar = (props) => {
  const [blogs, setBlogs] = useState([]);

  const SubmitHandler = (e) => {
    e.preventDefault();
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
    const year = date.getFullYear().toString().slice(-2);
    
    return `${day} ${month},${year}`;
  };

  useEffect(() => {
    // Fetch blogs dynamically
    getBlogs().then((data) => {
      setBlogs(data || []);
    });
  }, []);

  const recentPosts = blogs.slice(0, 3); // safe slicing

  return (
    <div className={`col col-lg-4 col-12 ${props.blLeft}`}>
      <div className="blog-sidebar">
        <div className="widget search-widget">
          <form onSubmit={SubmitHandler}>
            <div>
              <input type="text" className="form-control" placeholder="Search Post.." />
              <button type="submit"><i className="ti-search"></i></button>
            </div>
          </form>
        </div>
        <div className="widget category-widget">
          <ul>
            {/* {Services.slice(0,6).map((service, Sitem) => (...))} */}
          </ul>
        </div>
        <div className="widget recent-post-widget">
          <h3>Related Posts</h3>
          <div className="posts">
            {recentPosts.map((blog, Bitem) => (
              <div className="post" key={Bitem}>
                <div className="img-holder">
                  <img src={blog.screens} alt="" />
                </div>
                <div className="details">
                  <h4>
                    <Link onClick={ClickHandler} to={`/blog-single/${blog.id}`}>
                      {blog.blogTitle}
                    </Link>
                  </h4>
                  <span className="date">{formatDate(blog.created_at)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="widget tag-widget">
          <h3>Tags</h3>
          <ul>
            <li><Link onClick={ClickHandler} to="/blog-single/1">Planning</Link></li>
            <li><Link onClick={ClickHandler} to="/blog-single/1">Design</Link></li>
            <li><Link onClick={ClickHandler} to="/blog-single/1">creative</Link></li>
            <li><Link onClick={ClickHandler} to="/blog-single/1">Interior</Link></li>
            <li><Link onClick={ClickHandler} to="/blog-single/1">Furniture</Link></li>
            <li><Link onClick={ClickHandler} to="/blog-single/1">Idea</Link></li>
            <li><Link onClick={ClickHandler} to="/blog-single/1">Decoration</Link></li>
            <li><Link onClick={ClickHandler} to="/blog-single/1">Architectural</Link></li>
          </ul>
        </div>
        <div className="wpo-contact-widget widget">
          <h2>How We Can <br /> Help You!</h2>
          <p>
            Our team is dedicated to turning your vision into reality, whether you need innovative architectural design, interior solutions, or expert project management. We provide personalized guidance and creative expertise at every stage, ensuring your project is completed on time and exceeds expectations.
          </p>
          <Link onClick={ClickHandler} to="/contact">Contact Us</Link>
        </div>
      </div>
    </div>
  );
};

export default BlogSidebar;